import React from 'react';
import TopBar from './Topbar';
import Notice from './Notice';
import Dialog from './Dialog';

// --- UPDATED ---
// We now accept the props from App.js
export const Layout1 = ({ children, user, firstName, handleLogout, title,  globalNotice, setGlobalNotice, dialog , setGlobalDialog}) => {
  return (
    <>
      <TopBar  // Pass down the title
        user={user}                 // Pass down the REAL user
        firstName={firstName}       // Pass down the REAL first name
        handleLogout={handleLogout} // Pass down the logout function
      />
      {globalNotice && (
        <div className="fixed top-24 left-1/2 -translate-x-1/2 w-full max-w-md z-50 px-4">
          <Notice
            type={globalNotice.type}
            onClose={() => setGlobalNotice(null)} // Allows manual closing
          >
            {globalNotice.text}
          </Notice>
        </div>
      )}
      {
        dialog && (
        <div className="fixed top-1/2 left-1/2 -translate-x-1/2 w-full max-w-md z-50 px-4">
          <Dialog
          onClose={() => setGlobalDialog(null)}
          title= {`${dialog.title}`}
          onAccept={() => {
          if (dialog.onAcceptCallback) {
            dialog.onAcceptCallback(); // Run your stored function
          }
          setGlobalDialog(null); // Close the dialog
        }}
        >
          {/* This is the 'children' prop */}
          <p>{dialog.explanation}</p>
        </Dialog>
        </div>
        )
      }
      {children}
    </>
  );
};